var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
var DragPreview = (function (_super) {
    __extends(DragPreview, _super);
    function DragPreview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.printData = {};
        _this.mm2px = 3.7795275591;
        return _this;
    }
    DragPreview.prototype.getItemStyle = function (item) {
        var width = this.printData.print_width;
        var zoom = (width - 6) / width;
        return {
            'font-weight': item.is_bold == 1 ? 'bold' : 'normal',
            'text-decoration': item.is_italic == 1 ? 'underline' : 'none',
            'font-size': item.font_size + 'px',
            'left': item.x_coordinates + (3 * this.mm2px) + 'px',
            'top': item.y_coordinates + (2 * this.mm2px) + 'px',
            'width': item.width + 'px',
            'height': item.height + 'px',
            'zoom': zoom
        };
    };
    DragPreview = __decorate([
        Component({
            name: 'DragPreview',
            computed: {
                paperStyle: function () {
                    var _a = this.printData, print_width = _a.print_width, print_height = _a.print_height;
                    var ratio = 1;
                    var width = print_width;
                    var height = print_height;
                    var base_width = 160;
                    var base_height = 120;
                    var zoom = base_width / width;
                    return {
                        width: width + 'mm',
                        height: height + 'mm',
                        zoom: zoom
                    };
                }
            }
        })
    ], DragPreview);
    return DragPreview;
}(Vue));
export default DragPreview;
